import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "expandBtn", "icon"]

  toggle() {
    const list = this.listTarget
    const icon = this.iconTarget
    
    if (list.style.display === 'none') {
      list.style.display = 'block'
      icon.classList.remove('bi-chevron-down')
      icon.classList.add('bi-chevron-up')
    } else {
      list.style.display = 'none'
      icon.classList.remove('bi-chevron-up')
      icon.classList.add('bi-chevron-down')
    }
  }
}
